import { getDefaultLang } from "@cervval.js/common/src/i18n/languages";

const _fr = {
    titlePage: "Mes professionnels",
    addButton: "Ajouter un professionnel",
    html: {
        returnTitle: "Mon compte",
        listTitle: "Mes professionnels",
        appointmentsTitle: "Mes rendez-vous :"
    }
};

export type I18nProfessional = typeof _fr;

const _en: I18nProfessional = {
    titlePage: "My professionals",
    addButton: "Add a professional",
    html: {
        returnTitle: "My account",
        listTitle: "Mes professionals",
        appointmentsTitle: "My appointments :"
    }
};

/**
 * Return value in required language
 * @param lang Chosen lang
 * @returns 
 */
export function I18n(lang?: string): I18nProfessional {
    lang = lang ?? getDefaultLang();
    switch (lang) {
        case "en":
            return _en;
        case "fr":
        default:
            return _fr;
    }
}